import { render, staticRenderFns } from "./newAttackMethod.vue?vue&type=template&id=a5477c56&scoped=true"
import script from "./newAttackMethod.vue?vue&type=script&lang=js"
export * from "./newAttackMethod.vue?vue&type=script&lang=js"
import style0 from "./newAttackMethod.vue?vue&type=style&index=0&id=a5477c56&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5477c56",
  null
  
)

export default component.exports